import React from 'react';
import Tooltip from 'components/controls/Tooltip';

const MandatoryIcon: React.FunctionComponent<{ message?: string }> = ({ message }) => {
  return (
    <div>
      <svg viewBox="0 0 52 52" width="1rem" height="1rem">
        <path
          fill="#e75113"
          d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M28,41c0,1.104-0.896,2-2,2s-2-0.896-2-2v-2
   c0-1.104,0.896-2,2-2s2,0.896,2,2V41z M28,33c0,1.104-0.896,2-2,2s-2-0.896-2-2V11c0-1.104,0.896-2,2-2s2,0.896,2,2V33z"
        />
      </svg>
      {message && (
        <Tooltip position="right" offset={4}>
          {message}
        </Tooltip>
      )}
    </div>
  );
};

export default MandatoryIcon;
